import FormInfo from "../Inputs/FormInfo";

const formatTimestamp = (isoString) => {
  if (!isoString) return null;
  const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/.test(isoString) ? isoString : `${isoString}Z`;
  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) return null;
  const formatted = parsed.toLocaleString("en-GB", {
    timeZone: "UTC",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${formatted} UTC`;
};

const formatActor = (name, email, userId) => {
  if (name && email) return `${name} (${email})`;
  return name || email || userId || null;
};

const EntityAuditStrip = ({ auditInfo }) => {
  const items = [
    {
      label: "Created by",
      value: formatActor(
        auditInfo?.created_by_name,
        auditInfo?.created_by_email,
        auditInfo?.created_by
      ),
    },
    { label: "Created", value: formatTimestamp(auditInfo?.created_at) },
    {
      label: "Updated by",
      value: formatActor(
        auditInfo?.updated_by_name,
        auditInfo?.updated_by_email,
        auditInfo?.updated_by
      ),
    },
    { label: "Updated", value: formatTimestamp(auditInfo?.updated_at) },
  ].filter((item) => item.value);

  if (items.length === 0) return null;

  return (
    <div className="rounded border border-edge-gray-200 bg-fill-gray-50 px-4 py-3 dark:border-edge-gray-700 dark:bg-fill-gray-800/50">
      <div className="mb-2.5 flex items-center gap-1.5">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-ink-gray-500 dark:text-ink-gray-400">
          Audit
        </span>
        <FormInfo content="Recorded automatically by the platform. Not editable. All times are UTC." />
      </div>
      <dl className="flex flex-wrap gap-x-10 gap-y-4">
        {items.map((item) => (
          <div key={item.label} className="min-w-0">
            <dt className="mb-1 text-[10px] uppercase tracking-wide text-ink-gray-400">{item.label}</dt>
            <dd className="truncate text-xs text-ink-gray-700 dark:text-ink-gray-300" title={item.value}>
              {item.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default EntityAuditStrip;